import { KeyValue } from "@/main/models/common";
import { timeZoneFilterRequest } from "@/main/models/request/timeZone";

export enum TimeZoneTypes {
	GET_TIMEZONES_USER = "@timeZone/GET_TIMEZONES_USER",
	SAVE_TIMEZONES_USER = "@timeZone/SAVE_TIMEZONES_USER",
	RESET_REDUCER_TIMEZONES_USER = "@timeZone/RESET_REDUCER_TIMEZONES_USER",
}

export interface TimeZoneState {
	readonly timeZone: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetTimeZonesUser {
	type: typeof TimeZoneTypes.GET_TIMEZONES_USER;
	payload: {
		request: timeZoneFilterRequest;
	};
}

export interface SaveTimeZonesUser {
	type: typeof TimeZoneTypes.SAVE_TIMEZONES_USER;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerTimeZonesUser {
	type: typeof TimeZoneTypes.RESET_REDUCER_TIMEZONES_USER;
}

export type TimeZoneActionTypes = GetTimeZonesUser | SaveTimeZonesUser | ResetReducerTimeZonesUser;
